/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WarningCircleLarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WarningCircleLarge',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 14 * scale,
      viewBox: '0 0 14 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14M6 3v4h2V3zm0 6v2h2V9z","fill":"currentColor","fillRule":"evenodd"}))
}
